import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';

export interface SupportContactGroup {
  label: string;
  phone: string;
  email: string;
}

@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.scss']
})
export class SupportComponent implements OnInit {

  bookingId;

  // TODO: replace this dummy object with actual API response from getSupportData()
  supportData: any = {
    organisationName: 'Mobisoft Infotech',
    supportRole: 'Senior Support Specialist',
    availableNow: true,
    openNow: true,
    supportHours: 'Monday – Friday · 9:00 AM – 7:00 PM',
    poweredByName: 'Mobisoft Infotech',
    supportContacts: [
      {
        label: 'Support 01',
        phone: '+1 (800) 462-4766',
        email: 'support@mobisoft.com'
      },
      {
        label: 'Support 02',
        phone: '+1 (800) 462-4788',
        email: 'tech@mobisoft.com'
      }
    ]
  };

  organisationName = '';
  supportRole = '';
  supportHours = '';
  isAvailable = false;
  isOpenNow = false;
  poweredByName = '';
  contactGroups: SupportContactGroup[] = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private location: Location
  ) { }

  ngOnInit() {
    this.bookingId = this.route.snapshot.queryParams['id'];
    this.mapSupportViewModel(this.supportData);
  }

  closePopup(): void {
    if (window.history.length > 1) {
      this.location.back();
      return;
    }
    this.router.navigate(['/login']);
  }

  private mapSupportViewModel(result: any): void {
    this.organisationName = this.toText(result?.organisationName || result?.organizationName);
    this.supportRole = this.toText(result?.supportRole || result?.designation || result?.title);
    this.supportHours = this.toText(result?.supportHours || result?.businessHours || result?.supportTiming);
    this.poweredByName = this.toText(result?.poweredByName || this.organisationName);
    this.isAvailable = !!result?.availableNow || !!result?.isAvailable;
    this.isOpenNow = !!result?.openNow || !!result?.isOpenNow || this.isAvailable;

    const contacts = Array.isArray(result?.supportContacts) ? result.supportContacts : [];
    this.contactGroups = contacts
      .map((contact: any, index: number) => ({
        label: this.toText(contact?.label) || ('Support ' + ('0' + (index + 1)).slice(-2)),
        phone: this.toText(contact?.phone || contact?.phoneNumber),
        email: this.toText(contact?.email || contact?.supportEmail)
      }))
      .filter((group: SupportContactGroup) => !!(group.phone || group.email));
  }

  private toText(value: any): string {
    if (value === null || value === undefined) {
      return '';
    }
    return String(value).trim();
  }

  trackBySupportLabel(index: number, item: SupportContactGroup): string {
    return item.label + '-' + item.phone + '-' + item.email + '-' + index;
  }

  getPhoneHref(phone: string): string {
    return phone ? 'tel:' + phone.replace(/\s+/g, '') : '';
  }

  getEmailHref(email: string): string {
    return email ? 'mailto:' + email : '';
  }
}
